import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { TemaProvider } from "./components/ui/theme";
import { Layout } from "./components/layout/Layout";

// Pages
import HomePage from "./pages/HomePage";
import PersonasPage from "./pages/PersonasPage";
import EmpresasPage from "./pages/EmpresasPage";
import ProfesionalesPage from "./pages/ProfesionalesPage";
import AgendarPage from "./pages/AgendarPage";
import MisHorasPage from "./pages/MisHorasPage";
import PagoResultadoPage from "./pages/PagoResultadoPage";
import ValorarPage from "./pages/ValorarPage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import ContactoPage from "./pages/ContactoPage";
import TerminosPage from "./pages/legales/TerminosPage";
import PrivacidadPage from "./pages/legales/PrivacidadPage";
import ConsentimientoPage from "./pages/legales/ConsentimientoPage";
import PsychologistLogin from "./pages/PsychologistLogin";
import PsychologistDashboard from "./pages/PsychologistDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import RegistroProfesionalPage from "./pages/RegistroProfesionalPage";
import SesionPage from "./pages/SesionPage";
import EncuentraPage from "./pages/EncuentraPage";
import BonosPage from "./pages/BonosPage";
import ReprogramarPage from "./pages/ReprogramarPage";
import NoEncontradaPage from "./pages/NoEncontradaPage";

function App() {
  return (
    <TemaProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Públicas, con encabezado y pie */}
          <Route element={<Layout><HomePage /></Layout>} path="/" />
          <Route element={<Layout><PersonasPage /></Layout>} path="/personas" />
          <Route element={<Layout><EmpresasPage /></Layout>} path="/empresas" />
          <Route element={<Layout><ProfesionalesPage /></Layout>} path="/profesionales" />
          <Route element={<Layout><AgendarPage /></Layout>} path="/agendar" />
          <Route element={<Layout><EncuentraPage /></Layout>} path="/encuentra" />
          <Route element={<Layout><BonosPage /></Layout>} path="/bonos" />
          <Route element={<Layout><FAQPage /></Layout>} path="/faq" />
          <Route element={<Layout><BlogPage /></Layout>} path="/blog" />
          <Route element={<Layout><ContactoPage /></Layout>} path="/contacto" />

          {/* Portal del paciente: se entra con el código de continuidad */}
          <Route element={<Layout><MisHorasPage /></Layout>} path="/mis-horas" />
          <Route element={<Layout><PagoResultadoPage /></Layout>} path="/pago/resultado" />
          <Route element={<Layout><ValorarPage /></Layout>} path="/valorar/:token" />
          <Route element={<Layout><ReprogramarPage /></Layout>} path="/reprogramar/:bookingId" />

          {/* La sala va sin encabezado ni pie: ocupa la pantalla completa */}
          <Route path="/sesion/:token" element={<SesionPage />} />

          {/* Legales */}
          <Route element={<Layout><TerminosPage /></Layout>} path="/legales/terminos" />
          <Route element={<Layout><PrivacidadPage /></Layout>} path="/legales/privacidad" />
          <Route element={<Layout><ConsentimientoPage /></Layout>} path="/legales/consentimiento" />

          {/* Profesionales (sin layout) */}
          <Route path="/profesional/login" element={<PsychologistLogin />} />
          <Route path="/profesional/dashboard" element={<PsychologistDashboard />} />

          {/* Registro de profesionales: enlace privado, no aparece en ningún menú.
              El equipo lo envía a mano a quien quiere invitar. */}
          <Route path="/unete" element={<RegistroProfesionalPage />} />

          {/* Administración (sin layout, acceso restringido) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* Cualquier otra ruta */}
          <Route element={<Layout><NoEncontradaPage /></Layout>} path="*" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </TemaProvider>
  );
}

export default App;
